import { useEffect, useRef } from 'react';
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded befor being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */

function useCommittedRef(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref;
}

export default useCommittedRef;


//////////////////
// WEBPACK FOOTER
// ../~/@restart/hooks/esm/useCommittedRef.js
// module id = 1774
// module chunks = 121